import React from 'react';
import { Touchable, type TouchableProps } from './Touchable';

export type IconNavButtonProps = Omit<TouchableProps, 'haptic'>;

// min-w/min-h 11 = 44px, the WCAG 2.5.5 / Apple-HIG minimum touch target.
// inline-flex centers the (smaller) icon within that target.
const BASE =
  'inline-flex items-center justify-center min-w-11 min-h-11 p-2 rounded-full text-ink-faint active:bg-soft active:scale-95 transition-all touch-manipulation';

export const IconNavButton: React.FC<IconNavButtonProps> = ({ className, ...rest }) => (
  <Touchable haptic="softTap" className={className ? `${BASE} ${className}` : BASE} {...rest} />
);
